// extracted by mini-css-extract-plugin
module.exports = {"sliderNavigation":"post-slider_sliderNavigation__NnaaF","sliderPrev":"post-slider_sliderPrev__qohjI","sliderNext":"post-slider_sliderNext__bB_zH"};